import React, { FC } from 'react';
import routesByName from 'constants/routes';
import { Redirect, Route, RouteProps, useLocation } from 'react-router-dom';
import { useAuth } from 'modules';

const PrivateRoute: FC<RouteProps> = (props) => {
  const { children, ...otherProps } = props;
  const location = useLocation();
  const isAuth = useAuth();

  if (isAuth) {
    return <Route {...otherProps}>{children}</Route>;
  }

  return <Redirect to={{ pathname: routesByName.auth.index, state: { from: location } }} />;
};

export default PrivateRoute;
